<button
  class="fto-legacy-btn btn btn-primary"
  [attr.aut-id]="autId"
  [type]="buttonType"
  [disabled]="disabled || pending"
>
  @if (!pending) {
  <ng-content></ng-content>
  } @if (pending) {
  <spinner class="no-pad" colorName="white" size="small"></spinner>
  }
</button>
